import * as React from 'react';
import './ExcludeParagraph.css';
import { ParagraphMO } from '../../models/ParagraphMO';
import { FontIcon } from '@fluentui/react/lib/Icon';

export interface AppProps {
	//
	// title: string;
	// score;

	paragraphs: ParagraphMO[];
}

export interface AppState {
	//
	isOpen: boolean;
}

class ExcludeParagraph extends React.Component<AppProps, AppState> {
	constructor(props, context) {
		super(props, context);

		this.state = { isOpen: false };
	}

	componentDidMount() {
		//
	}

	componentWillUnmount() {
		//
	}

	clickHandler() {
		this.setState({
			isOpen: !this.state.isOpen,
		});
	}

	renderBrief() {
		//
		const { paragraphs } = this.props;
		let title: string = '';

		for (let i = 0; i < Math.min(paragraphs[0].words.length, 5); i++) {
			title += paragraphs[0].words[i].word + ' ';
		}

		return <div>{title.trim()}</div>;
	}

	renderFull() {
		const { paragraphs } = this.props;
		let listItems: JSX.Element[] = [];

		for (let i = 0; i < paragraphs.length; i++) {
			listItems.push(<div>{paragraphs[i].text}</div>);
		}
		return listItems;
	}

	render() {
		const { isOpen } = this.state;
		return (
			<div className="ex-content" onClick={() => this.clickHandler()}>
				<div className="expander-btn">
					<FontIcon
						iconName="ChevronDown"
						className={isOpen ? 'open' : 'close'}
					/>
				</div>
				{isOpen ? this.renderFull() : this.renderBrief()}
			</div>
		);
	}
}

export default ExcludeParagraph;
